import { getUserData } from '@/constants/global';
import { type IApiResponse, type INotification, type INotificationResponse } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const roleQuery = () => {
	const userRoles = getUserData().user?.role as string[];
	if (Array.isArray(userRoles) && !userRoles?.length) return '';
	return userRoles?.map((role, index) => `Role=${role}${index === userRoles.length - 1 ? '' : '&'}`).join('');
};

const notificationApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAllNotification: builder.query<IApiResponse<INotificationResponse>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Notification${getCommandQuery(paged, ...(query || []))}&${roleQuery()}`,
			}),
		}),
		getNotificationById: builder.query<IApiResponse<INotification>, { id: string }>({
			query: ({ id }) => ({
				url: `/Notification/${id}`,
			}),
		}),
		deleteNotification: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/Notification/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useDeleteNotificationMutation,
	useGetAllNotificationQuery,
	useLazyGetAllNotificationQuery,
	useGetNotificationByIdQuery,
} = notificationApiSlice;
